import { render, staticRenderFns } from "./topTenProject.vue?vue&type=template&id=99f27d24&scoped=true&"
import script from "./topTenProject.vue?vue&type=script&lang=js&"
export * from "./topTenProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f27d24",
  null
  
)

export default component.exports